import { useEffect, useState } from 'react'
import { AspectRatio, Collapse, Image } from '@mantine/core'
import { IconChevronRight, IconCirclePlus } from '@tabler/icons-react'
import { Typography } from '../../common/typography'
import { CompetitionTeam } from '../../performance/api'
import classes from './ComparePicker.module.css'
import { CompareSubject } from '../../compare/Compare'

export default function ComparePickerRow({
  id,
  image,
  name,
  type,
  subject,
  setSubject,
  close,
  team,
  shouldExpand = false,
}: {
  id: number
  image: string
  name: string
  type: 'team' | 'user' | 'overall'
  subject: CompareSubject
  setSubject: React.Dispatch<React.SetStateAction<CompareSubject>>
  close: () => void
  team?: CompetitionTeam
  shouldExpand?: boolean
}) {
  const [isExpanded, setIsExpanded] = useState<boolean>(shouldExpand)

  useEffect(() => {
    setIsExpanded(shouldExpand)
  }, [shouldExpand])

  const toggleExpand = (e: React.MouseEvent) => {
    e.stopPropagation()
    setIsExpanded(!isExpanded)
  }

  function handleAddSubject() {
    if (type === 'overall') {
      setSubject({
        type: 'overall',
        id,
        name,
        photo: image,
      })
    } else {
      setSubject({
        type: 'team',
        id,
        name: team?.team_name || '',
        photo: team?.team_logo.main || '',
      })
    }
    close()
  }
  return (
    <>
      <div
        className={classes.rowContainer}
        data-selected={
          (subject?.type === 'team' && subject.id === id) ||
          (subject?.type === 'overall' && subject.id === id)
        }
        onClick={type === 'team' ? toggleExpand : handleAddSubject}
      >
        <div className={classes.data}>
          <AspectRatio ratio={1 / 1}>
            <Image
              src={image}
              alt={name}
              className={classes.image}
              fit="scale-down"
            />
          </AspectRatio>

          <Typography fs="md" lh="140">
            {name}
          </Typography>
        </div>
        <div className={classes.actionsContainer}>
          <IconCirclePlus onClick={handleAddSubject} />
          {type === 'team' && (
            <IconChevronRight
              className={classes.chevron}
              data-expanded={isExpanded}
            />
          )}
        </div>
      </div>

      {type === 'team' && team?.players && (
        <Collapse
          in={isExpanded}
          transitionDuration={200}
          transitionTimingFunction="ease-in-out"
        >
          {team.players.map((player) => (
            <div
              key={player.player_id}
              className={classes.playersContainer}
              data-selected={
                subject?.type === 'user' && subject.id === player.user_id
              }
            >
              <div className={classes.data}>
                <AspectRatio ratio={1 / 1}>
                  <Image
                    src={player.player_photo.thumbnail}
                    alt={player.player_name}
                    className={classes.playerImage}
                    fit="scale-down"
                  />
                </AspectRatio>
                <Typography fs="sm" lh="150">
                  {player.player_name}
                </Typography>
              </div>
              <IconCirclePlus
                onClick={() => {
                  setSubject({
                    type: 'user',
                    id: player.user_id || 0,
                    player_id: player.player_id,
                    name: player.player_name,
                    photo: player.player_photo.main,
                    team_logo: team.team_logo.mini,
                  })
                  close()
                }}
              />
            </div>
          ))}
        </Collapse>
      )}
    </>
  )
}
